exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TwitterDialog_twitterDialog__29rzM .TwitterDialog_containerInputTag__1mYps {\n  display: -webkit-flex;\n  display: flex; }\n  .TwitterDialog_twitterDialog__29rzM .TwitterDialog_containerInputTag__1mYps .TwitterDialog_inputTag__2ohde {\n    min-width: 43%; }\n\n.TwitterDialog_twitterDialog__29rzM .TwitterDialog_containerTags__3v2h0 {\n  max-height: 300px;\n  overflow: auto; }\n  .TwitterDialog_twitterDialog__29rzM .TwitterDialog_containerTags__3v2h0 .TwitterDialog_chipTag__3AQIc {\n    margin: 3px;\n    letter-spacing: 1px;\n    padding: 20px 0px; }\n    .TwitterDialog_twitterDialog__29rzM .TwitterDialog_containerTags__3v2h0 .TwitterDialog_chipTag__3AQIc .TwitterDialog_twitterName__2zuqh {\n      font-weight: bold; }\n", ""]);

// exports
exports.locals = {
	"twitterDialog": "TwitterDialog_twitterDialog__29rzM",
	"containerInputTag": "TwitterDialog_containerInputTag__1mYps",
	"inputTag": "TwitterDialog_inputTag__2ohde",
	"containerTags": "TwitterDialog_containerTags__3v2h0",
	"chipTag": "TwitterDialog_chipTag__3AQIc",
	"twitterName": "TwitterDialog_twitterName__2zuqh"
};